import { Controller, useFormContext } from 'react-hook-form'

import { typesOfFinancialInstitution } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Type = () => {
  const { control, clearErrors } = useFormContext<SarEdit>()

  return (
    <Controller
      name="institutionContactInfo.type"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) => (
        <FF2
          required
          field={field}
          label="79. Type of financial institution"
          input={(props) => (
            <Select
              {...props}
              data={typesOfFinancialInstitution}
              data-qa="79. Type of financial institution"
              options-data-qa="79. Type of financial institution option"
              onChange={(value) => {
                if (value === 'Other') {
                  clearErrors('institutionContactInfo.typeOther')
                }
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
